import React, { Component } from 'react';

export default class extends Component {
    render() {
        const date = new Date()
        return (
            <div className="text-center f_10 mar_0">
                Copyright &#169; {date.getFullYear()} Aspenify
            </div>
        );
    }
}
